import { configureStore } from '@reduxjs/toolkit';
import tramitesReducer from './tramites/tramites';

const store = configureStore({
  reducer: {
    tramites: tramitesReducer,
  },
});

export default store;

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
